import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
	selector: 'formly-label',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="mb-3">
			<label
				class="form-label text-muted"
				style="font-size: 0.875rem; margin-bottom: 0.25rem;"
			>
				{{ props.label }}
			</label>
			<div class="fw-bold" style="font-size: 1rem;">
				{{ formControl.value || props.defaultValue || 'N/A' }}
			</div>
		</div>
	`,
})
export class FormlyLabelType extends FieldType<FieldTypeConfig> {}
